import { Nav, Navbar } from "react-bootstrap";
import { AiFillDashboard, AiOutlineLogout } from "react-icons/ai";
import { MdBedroomParent } from "react-icons/md";
import { FaRegCalendarAlt } from "react-icons/fa";

import { useState } from "react";
import { Link } from "react-router-dom";
import User from "../components/User";
import Dashboard from "../components/Dashboard";
import Hotel from "../components/Hotel";
import BlackList from "../components/BlackList";
import Reservation from "../components/Reservation";
import { FaRegCircleUser } from "react-icons/fa6";
import { PiListPlus } from "react-icons/pi";
import { RiBillLine } from "react-icons/ri";
import Bills from "../components/Bills";

export default function DevAdmin(){
    const [dashboard, setDasboard] = useState(true)
    const [users, setUser] = useState(false)
    const [hotels, setHotel] = useState(false)
    const [blackList, setBlackList] = useState(false)
    const [reservation, setReservation] = useState(false)
    const [bills, setBills] = useState(false)


    return(
        <div className="h-100" >
            
            <div className="bg-secondary d-flex h-100 border">
                <Nav defaultActiveKey="/home" className=" border flex-column ps-2 pe-2 h-100">
                    <Navbar.Brand href="#home" className='nav-link text-center text-black fs-3 fw-bold mt-3 border-bottom pb-4'><span className=" bg-primary bg-gradient p-2 text-center rounded-3 text-white m-1">Komorotel.com</span></Navbar.Brand>
                    <p className="text-light fw-bold m-0 mt-2 ms-1 mb-1">Main</p>
                    <Nav.Link onClick={()=>{setDasboard(true); setUser(false); setHotel(false); setBlackList(false); setReservation(false)}} className="text-light fs-5 border-bottom pb-4"><AiFillDashboard className="mb-1 " /> Dashboard</Nav.Link>
                        
                    
                    <p className="text-light fw-bold m-0 mt-2 ms-1 mb-1">List</p>
                    <Nav.Link onClick={()=>{setUser(true); setDasboard(false); setHotel(false); setBlackList(false); setReservation(false); setBills(false)}} className="text-light fs-5 "><FaRegCircleUser className='mb-1 me-1' />Users</Nav.Link>
                    <Nav.Link onClick={()=>{setHotel(true); setDasboard(false); setUser(false); setBlackList(false); setReservation(false); setBills(false)}} className="text-light fs-5"><MdBedroomParent className="mb-1  fs-6 me-1" />Hotels</Nav.Link>
                    <Nav.Link onClick={()=>{setBlackList(true); setDasboard(false); setUser(false); setHotel(false); setReservation(false); setBills(false)}} className="text-light fs-5"><PiListPlus className="mb-1  me-1" />BlackList</Nav.Link>
                    <Nav.Link onClick={()=>{setReservation(true); setDasboard(false); setUser(false); setBlackList(false); setHotel(false); setBills(false)}} className="text-light fs-5"><FaRegCalendarAlt className="mb-1  fs-6 me-1" />Reservation</Nav.Link>
                    <Nav.Link onClick={()=>{setBills(true); setReservation(false); setDasboard(false); setUser(false); setBlackList(false); setHotel(false)}} className="text-light fs-5 pb-4 border-bottom"><RiBillLine className="mb-1  fs-6 me-1" />Bills</Nav.Link>




                    
                    <Nav.Link as={Link} to={"/"} className="text-light fs-5 pb-4"><AiOutlineLogout className="mb-1 me-1 fs-6"/>Logout</Nav.Link>


                </Nav>
                {dashboard ? (
                    <div className="bg-white d-flex w-100 h-100 justify-content-center">
                        <Dashboard/>
                    </div>): null}
                {hotels ? (
                    <div className="bg-white d-flex border w-100 h-100 justify-content-center">
                        <Hotel/>
                    </div>):null
                }
                {users ? (
                    <div className="bg-white d-flex w-100 h-100 justify-content-center">
                        <User/>
                    </div>):null
                }
                {blackList ? (
                    <div className="bg-white d-flex w-100 h-100 justify-content-center">
                        <BlackList/>
                    </div>):null
                }
                {reservation ? (
                    <div className="bg-white d-flex w-100 h-100 justify-content-center">
                         <Reservation/>
                    </div>):null
                }
                {bills ? (
                    <div className="bg-white d-flex w-100 h-100 justify-content-center">
                         <Bills/>
                    </div>):null
                }
            </div>
        </div>
    )
}